import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonial-details',
  templateUrl: './testimonial-details.component.html',
  styleUrls: ['./testimonial-details.component.scss']
})
export class TestimonialDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
